export const Yetki = {
  SUPERADMIN: 1024,
  ADMIN: 512,
  ULKE: 96,
  BOLGE: 128,
  IL: 64,
  ILCE: 32,
  HOCA: 16,
  TALEBE: 8
}

export const DersDurum = {
  BASLAMADI: 0,
  BASLAYACAK: 1,
  BASLADI: 2,
  BITECEK: 3,
  BITTI: 4,
  IPTAL: 5
}

export const RaporDurum = {
  SIRADA: 1,
  ISLEMDE: 2,
  HATA: 3,
  TAMAMLANDI: 4,
  SILINDI: 5
}

export const EgitimTuru = {
  UZAKTAN: 1,
  YUZYUZE: 2
}
